<template>
    <el-drawer
        title="自定义模块"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="1200px"
        :before-close="close">
        <div class="panel fx-g1">
            <vue-neditor-wrap v-model="form.content" :config="myConfig" :destroy="false" ></vue-neditor-wrap>
        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">确 定</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>

</style>


<script>

    import VueNeditorWrap from 'vue-neditor-wrap'

    export default {
        props: [
            "item",
        ],
        components: {
            VueNeditorWrap
        },
        data() {
            return {
                show: false,
                form: {...this.item, type: 2},
                myConfig: {
                    // 如果需要上传功能,找后端小伙伴要服务器接口地址
                    serverUrl: '/api/web/upload/ueditor',
                    UEDITOR_HOME_URL: '/admin/NEditor/',
                    // 编辑器不自动被内容撑高
                    autoHeightEnabled: false,
                    // 初始容器高度
                    initialFrameHeight: 600,
                    // 初始容器宽度
                    initialFrameWidth: '100%',
                    // 关闭自动保存
                    enableAutoSave: true,
                    maximumWords:2000
                },
            }

        },


        methods: {
            close() {
                this.$emit("close");
            },
            sub() {
                this.$emit("submit", this.form);
                return false;
            },

        },
        mounted() {
            this.show = true;
        },
        created() {

        }


    }
</script>
